import Pressable from '@/components/motion/pressable';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { PropsWithChildren, ReactNode } from 'react';

type AuthPinButtonProps = PropsWithChildren<{
	onClick?: () => void;
	disabled?: boolean;
	ariaLabel?: string;
	icon?: ReactNode;
}>;

export default function AuthPinButton({ children, onClick, disabled, ariaLabel, icon }: AuthPinButtonProps) {
	return (
		<Pressable className='rounded-2xl'>
			<Button
				type='button'
				variant='outline'
				disabled={disabled}
				aria-label={ariaLabel}
				className={cn(
					'h-[60px] w-[60px] max-h-[60px] max-w-[60px] rounded-2xl border-white/15 bg-white/5 text-xl text-[var(--auth-white)] shadow-sm backdrop-blur-sm',
					'transition-shadow hover:border-[var(--auth-red)]/40 hover:bg-white/10 active:ring-1 active:ring-[var(--auth-red)]/40',
					icon && 'text-white/60',
				)}
				onClick={onClick}
			>
				{icon ?? children}
			</Button>
		</Pressable>
	);
}
